"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorPalettesSearch = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));
var _InputAdornment = _interopRequireDefault(require("@material-ui/core/InputAdornment"));
var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));
var _Refresh = _interopRequireDefault(require("@material-ui/icons/Refresh"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _i18n = require("../../../../../Framework/i18n");
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _styles = require("@material-ui/core/styles");
var _withWidth = require("@material-ui/core/withWidth");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var styles = function styles(theme) {
  return {
    textFieldInput: {
      padding: 10,
      marginTop: 1
    },
    noColorWrapper: {
      color: theme.palette.secondary.light,
      textAlign: 'center'
    },
    searchCloseTypography: {
      color: theme.palette.secondary.light,
      display: 'inherit',
      paddingTop: 15,
      '& span:last-child': {
        marginLeft: 10
      },
      '&:hover': {
        cursor: 'pointer'
      }
    },
    iconNoColorFound: {
      color: theme.palette.secondary.light,
      fontSize: 72
    },
    colorsWrap: function colorsWrap(_ref) {
      var heightColorPaletteWrapper = _ref.heightColorPaletteWrapper,
        width = _ref.width;
      return {
        display: 'flex',
        padding: '0 16px',
        maxHeight: (0, _withWidth.isWidthDown)('xs', width) ? heightColorPaletteWrapper : 250,
        flexWrap: 'wrap',
        overflowY: 'auto'
      };
    },
    colorSearchWrap: {
      display: 'flex',
      justifyContent: 'center'
    }
  };
};
var ColorPalettesSearch = exports.ColorPalettesSearch = (0, _styles.withStyles)(styles, {
  name: 'ColorPalettesSearch'
})(function (props) {
  var _useState = (0, _react.useState)(props.searchPalette),
    _useState2 = _slicedToArray(_useState, 2),
    filteredColors = _useState2[0],
    setFilteredColors = _useState2[1];
  var onSearch = function onSearch(searchText) {
    var searchPalette = props.searchPalette;
    var filterColors = searchPalette.colors && {
      colors: searchPalette.colors.filter(function (color) {
        return color.title.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
      })
    };
    var filteredColorPalette = _objectSpread(_objectSpread({}, searchPalette), {}, {
      colors: filterColors.colors
    });
    setFilteredColors(filteredColorPalette);
  };
  var keyUp = function keyUp() {
    onSearch(props.searchText);
  };
  return props.isSearchActive && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    variant: "outlined",
    fullWidth: true,
    value: props.searchText,
    onChange: props.changeText,
    onKeyUp: keyUp,
    margin: "normal",
    InputProps: {
      endAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "end"
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        "aria-label": "Toggle password visibility",
        onClick: function onClick() {
          return onSearch(props.searchText);
        }
      }, /*#__PURE__*/_react["default"].createElement(_Search["default"], null))),
      classes: {
        inputAdornedEnd: props.classes.textFieldInput
      }
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: props.classes.colorSearchWrap
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    classes: {
      root: props.classes.searchCloseTypography
    },
    onClick: props.closeSearch,
    noWrap: true
  }, /*#__PURE__*/_react["default"].createElement(_Refresh["default"], null), /*#__PURE__*/_react["default"].createElement("span", null, (0, _i18n.t)('colorPalettes.resetSearch')))), filteredColors.colors.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: props.classes.colorsWrap
  }, props.renderColors(filteredColors)), filteredColors && filteredColors.colors && filteredColors.colors.length === 0 && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    component: "div",
    classes: {
      root: props.classes.noColorWrapper
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    classes: {
      root: props.classes.iconNoColorFound
    }
  }, "format_color_reset"), /*#__PURE__*/_react["default"].createElement("div", null, (0, _i18n.t)('colorPalettes.colorNotFound'))));
});